module.exports = __webpack_public_path__ + "static/img/servicesImg2.d5ecd415.png";